var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const DEFAULT_PACKAGE_RESOLVE_MODE = 'local-first';
function getRuntimeGlobal() {
    return globalThis;
}
function normalizeMode(value) {
    if (value === 'offline-only') {
        return 'offline-only';
    }
    if (value === 'local-first') {
        return 'local-first';
    }
    return DEFAULT_PACKAGE_RESOLVE_MODE;
}
function getDefaultPublicBaseUrl() {
    var _a;
    const href = ((_a = getRuntimeGlobal().location) === null || _a === void 0 ? void 0 : _a.href) || 'http://localhost/';
    return new URL('./', href).toString();
}
function withoutLeadingSlash(path) {
    return path.replace(/^\/+/, '');
}
function joinHost(parts) {
    return parts.join(String.fromCharCode(46));
}
export function getSandpackRuntimeConfig() {
    const runtimeConfig = getRuntimeGlobal().__SANDPACK_RUNTIME_CONFIG__ || {};
    return {
        packageResolveMode: normalizeMode(runtimeConfig.packageResolveMode),
        publicBaseUrl: runtimeConfig.publicBaseUrl || getDefaultPublicBaseUrl(),
    };
}
export function isOfflineOnlyPackageResolveMode() {
    return getSandpackRuntimeConfig().packageResolveMode === 'offline-only';
}
export function getOfflinePackageBaseUrl() {
    return new URL('__sandpack_packages__/', getSandpackRuntimeConfig().publicBaseUrl).toString();
}
export function getOfflineCodesandboxUrl(path) {
    return new URL(`codesandbox/${withoutLeadingSlash(path)}`, getOfflinePackageBaseUrl()).toString();
}
export function getOfflineJsdelivrDataUrl(path) {
    return new URL(`jsdelivr-data/${withoutLeadingSlash(path)}`, getOfflinePackageBaseUrl()).toString();
}
export function getOfflineJsdelivrNpmUrl(path) {
    return new URL(`jsdelivr-npm/${withoutLeadingSlash(path)}`, getOfflinePackageBaseUrl()).toString();
}
export function createOfflinePackageError(url) {
    return new Error(`Sandpack offline package missing: ${url}`);
}
export function fetchOfflinePackage(url) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield getRuntimeGlobal().fetch(url);
        if (!response.ok) {
            throw createOfflinePackageError(url);
        }
        return response;
    });
}
export function getRemoteCodesandboxBucketUrl(env) {
    const prefix = env === 'dev' ? 'dev' : 'prod';
    return `https://${joinHost([
        `${prefix}-packager-packages`,
        'codesandbox',
        'io',
    ])}`;
}
export function getRemoteCodesandboxPackagerUrl(env) {
    if (env === 'dev') {
        return `https://${joinHost([
            'xi5p9f7czk',
            'execute-api',
            'eu-west-1',
            'amazonaws',
            'com',
        ])}/dev/packages`;
    }
    return `https://${joinHost([
        'aiwi8rnkp5',
        'execute-api',
        'eu-west-1',
        'amazonaws',
        'com',
    ])}/prod/packages`;
}
export function getRemoteJsdelivrNpmUrl(path) {
    return `https://${joinHost(['cdn', 'jsdelivr', 'net'])}/${withoutLeadingSlash(path)}`;
}
export function getRemoteJsdelivrDataUrl(path) {
    return `https://${joinHost(['data', 'jsdelivr', 'com'])}/${withoutLeadingSlash(path)}`;
}
export function getRemoteGithubApiUrl(path) {
    return `https://${joinHost(['api', 'github', 'com'])}/${withoutLeadingSlash(path)}`;
}
